"use strict";
exports.__esModule = true;
exports.FeedbackRoute = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var FeedbackPopup_1 = require("./FeedbackPopup");
var FeedbackRoute = function () {
    return (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: "/feedback", component: FeedbackPopup_1.FeedbackPopup }, void 0);
};
exports.FeedbackRoute = FeedbackRoute;
//# sourceMappingURL=FeedbackRoute.js.map